import { Badge } from '@/components/ui/badge'
import type { EstadoComunicacionUI } from '@/types/afip'

/**
 * Estado de una comunicación del Domicilio Fiscal Electrónico, como lo informa ARCA.
 *
 * `raw` es el texto original de ARCA y se muestra cuando el estado no cae en ninguno de los tres
 * conocidos. El estado dice cómo figura la comunicación, no si abrirla necesita la confirmación
 * legal: son dos preguntas distintas y una comunicación aceptada también puede necesitarla.
 */
export function EstadoBadge({
  estado,
  raw,
}: {
  estado: EstadoComunicacionUI
  raw: string
}) {
  switch (estado) {
    case 'NO_LEIDA':
      return <Badge variant="destructive">No leída</Badge>
    case 'LEIDA':
      return (
        <Badge variant="secondary" className="font-normal">
          Leída
        </Badge>
      )
    case 'ACEPTADA':
      return <Badge variant="outline">Aceptada</Badge>
    default:
      return (
        <Badge variant="outline" className="font-normal">
          {raw || estado}
        </Badge>
      )
  }
}
